/**
 * Auth persisted slice actions.
 * This file exists to break circular dependencies between brightback-auth.slice.ts and brightback-session.ts
 */

import { createAction } from '@reduxjs/toolkit';

const REDUCER_NAME = 'authPersisted-rtk';

// Action to clear tokens - matches the action created by authPersistedSlice.reducers.clearTokens
export const clearTokensAction = createAction(`${REDUCER_NAME}/clearTokens`);
